import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isLeapYear from 'dayjs/plugin/isLeapYear';

dayjs.extend(utc);
dayjs.extend(isLeapYear);

export function isFirstDateOfMonth(date: Date): boolean{
  if(!date) return false;

  return date.getDate() === 1;
}

export function isEndDateOfMonth(date: Date): boolean{
  if(!date) return false;

  const lastDate = new Date(date);
  lastDate.setDate(lastDate.getDate() + 1);
  return lastDate.getDate() === 1;
}

export function date_end_date_of_the_month(date: Date): Date{
  let result = date_clone(date);
  result.setMonth(result.getMonth() + 1);
  result.setDate(0);
  return result;
}

export function date_add_days(date: Date, days: number): Date{
  const result = date_clone(date);
  result.setDate(result.getDate() + days);

  return result;
}

export function date_clone(date: Date): Date{
  return new Date(date);
}

export function utc_date(str: string | Date): Date{
  return dayjs.utc(str).toDate();
}

export function seconds_to_duration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function date_valid(date: Date): boolean{
  if(!date) return false;
  if(isNaN(date as any)) return false;
  return true;
}

export function parse_date(str: string): Date{
  return dayjs(str).toDate();
}

// Only get date without time
export function local_date(str: string): Date{
  if(str && typeof str === 'string'){
    const regDate = /^(\d{4}-\d{2}-\d{2})T/i;
    if(regDate.test(str)){
      const match = regDate.exec(str);
      if(match && match[1]){
        return dayjs(match[1]).toDate();
      }
    }
    // 2023-07-31T00:00:00Z
    // Return "Z" from the end of the string
    str = str.replace(/Z$/i, '');
  }
  
  const date = dayjs(str).toDate();
  return date;
}

export function format_date(date: Date, format: string): string{
  return dayjs(date).format(format);
}

export function local_to_utc(date: Date | string): Date{
  return dayjs.utc(dayjs(date).format(`YYYY-MM-DD[T]00:00:00[Z]`)).toDate();
}

export function utc_now(): Date{
  const now = new Date();

  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
}

(window as any).local_date = local_date;
(window as any).local_to_utc = local_to_utc;
(window as any).dayjs = dayjs;
